module.exports = "/work-site/img/fix_history.7389efb0.png";